import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_942a3lwgm1: FaireBrandEntity = {
  token: "b_942a3lwgm1",
  type: "brand",
  name: "PS Seasoning",
  avatarUrl:
    "https://cdn.faire.com/fastly/c55bb0389d7290d555644693e2fbb3c84e47556e5293a4e37a3efedff7f8616c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/98e9a03c4d0568483fc1b5bf7d8f4aaa48c764e55be7b3999dd5a59fafe7bc8c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c55bb0389d7290d555644693e2fbb3c84e47556e5293a4e37a3efedff7f8616c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/98e9a03c4d0568483fc1b5bf7d8f4aaa48c764e55be7b3999dd5a59fafe7bc8c.jpeg",
  location: "Iron Ridge, WI, USA",
  minimumOrderDollars: 100,
  rating: 4.7,
  reviewCount: 234,
  isTopShop: true,
  isInsider: true,
  description:
    "At PS Seasoning, our craft is flavor. For generations, we’ve dedicated ourselves to crafting the most memorable flavor profiles and experiences. To us, it’s more than just food. No matter what you are creating, we know it will be enjoyed and remembered to the very last bite.\n\nOur unique flavor profiles are designed to make cooking easy, flavorful and fun and have been featured on Good Morning America, Fox News, USA Today, and the kitchen. With profiles that range from On The Rocks Bourbon Pepper to Adobo Honey and everything in between, we want everything you eat to be memorable. All of our products are crafted and blended in Iron Ridge, WI, USA, from our family to yours. \n\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:09.893Z",
    importedBy: "entity-db-cli",
  },
};
